// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tFWV","textarea":"styles_textarea__nrL29"};